export const environment = {
  production: true,
  buildId: '11060-20250805.1'
};
